import { parseWeekStartDate } from './dateUtility';

const normalizeDate = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const getTodayInUkCalendar = (now: Date = new Date()): Date => {
    try {
        const formatter = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/London',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
        const dateParts = formatter.formatToParts(now);
        const day = Number(dateParts.find(part => part.type === 'day')?.value);
        const month = Number(dateParts.find(part => part.type === 'month')?.value);
        const year = Number(dateParts.find(part => part.type === 'year')?.value);

        if (Number.isFinite(day) && Number.isFinite(month) && Number.isFinite(year)) {
            return new Date(year, month - 1, day);
        }
    } catch {
        // Fall back to the browser calendar where named timezone support is unavailable.
    }

    return normalizeDate(now);
};

export const isForecastWeekInPast = (
    weekStartDate: string,
    allowPastWeeks = false,
    today: Date = getTodayInUkCalendar()
): boolean => {
    const weekStart = parseWeekStartDate(weekStartDate);
    if (!weekStart) return true;
    if (allowPastWeeks) return false;

    const nextWeekStart = new Date(weekStart);
    nextWeekStart.setDate(nextWeekStart.getDate() + 7);

    return nextWeekStart <= normalizeDate(today);
};

export const getEditableForecastWeekStarts = (
    weekStartDates: string[],
    allowPastWeeks = false,
    today: Date = getTodayInUkCalendar()
): string[] => weekStartDates.filter(
    weekStartDate => !isForecastWeekInPast(weekStartDate, allowPastWeeks, today)
);

export const getEarliestEditableForecastWeekStart = (
    weekStartDates: string[],
    allowPastWeeks = false,
    today: Date = getTodayInUkCalendar()
): string | null => {
    const editableWeekStarts = getEditableForecastWeekStarts(
        weekStartDates,
        allowPastWeeks,
        today
    );

    return editableWeekStarts.length > 0 ? editableWeekStarts[0] : null;
};
